import { render, staticRenderFns } from "./follow_button.vue?vue&type=template&id=471a258f&scoped=true&"
import script from "./follow_button.vue?vue&type=script&lang=coffee&"
export * from "./follow_button.vue?vue&type=script&lang=coffee&"
import style0 from "./follow_button.vue?vue&type=style&index=0&id=471a258f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a258f",
  null
  
)

export default component.exports